import { TEAM_MEMBER_VALUES } from "~/common/constants";
import { TeamMemberWithOrganizationTeamMembers } from "~/common/utils";

export const hasAccountConfigured = (
  teamMember?: TeamMemberWithOrganizationTeamMembers,
) => {
  if (teamMember?.type === TEAM_MEMBER_VALUES.provider) {
    const { name, last_name, signature_name } = teamMember;

    return [name, last_name, signature_name].every(Boolean);
  }

  return false;
};
